/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';
import * as angular from 'angular';

angular.module('ticketspaceApp').factory('firebasePriorities', [
	'fbConnection',
	'$firebaseArray',
	function (fbConnection, $firebaseArray) {
		let defaultPriorities = [
			{
				color: '#5cbf3a',
				text: 'On track',
				sortOrder: 1,
			},
			{
				color: 'orange',
				text: 'Needs Attention',
				sortOrder: 2,
			},
			{
				color: 'firebrick',
				text: 'Critical',
				sortOrder: 3,
			},
		];

		function assembleDefault(ref) {
			let obj = {};
			defaultPriorities.forEach(function (p) {
				let key = ref.push().key;
				obj[key] = p;
			}, this);
			return obj;
		}

		function PriorityFactory(ref) {
			let query = ref.orderByChild('sortOrder'); //TODO - add security rules index
			return $firebaseArray.call(this, query);
		}
		PriorityFactory.prototype = {
			setDefault: function setDefault() {
				let obj = assembleDefault(this.$ref().ref);
				this.$ref().ref.set(obj);
			},
		};

		let returnObj = $firebaseArray.$extend(PriorityFactory);
		returnObj.assembleDefault = assembleDefault;
		return returnObj;
	},
]);
